exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3 {\r\n    margin-bottom: 0px;\r\n}\r\n\r\nmat-list {\r\n    max-height: 300px;\r\n    overflow-y: auto;\r\n    padding: 0px;\r\n    border: 1px solid #DADADA;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n#links-section {\r\n    margin-top: 25px;\r\n}\r\n\r\n.form {\r\n    margin-top: 15px;\r\n}\r\n\r\n.full-width {\r\n    width: 100%;\r\n}\r\n\r\n.align-right {\r\n    text-align: right;\r\n    display: block;\r\n}\r\n\r\n.small-spacing {\r\n    padding-bottom: 5px;\r\n}\r\n\r\n.half-width-left {\r\n    width: 50%;\r\n    text-align: left;\r\n}\r\n\r\n.half-width-right {\r\n    width: 50%;\r\n    text-align: right;\r\n}\r\n\r\n.image-label {\r\n    color: rgba(0,0,0,.54);\r\n    font-family: Roboto,\"Helvetica Neue\",sans-serif;\r\n    font-size: inherit;\r\n    font-weight: 400;\r\n    margin-top: 0px;\r\n}\r\n\r\n.image-input {\r\n    vertical-align: top;\r\n}\r\n\r\n.image-container {\r\n    margin-bottom: 25px;\r\n}\r\n\r\n.image-container img {\r\n    margin: auto;\r\n    display: block;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Repos/seeya/src/app/generator/add-edit-scene-dialog/add-edit-scene-dialog.component.css
// module id = ../../../../../src/app/generator/add-edit-scene-dialog/add-edit-scene-dialog.component.css
// module chunks = main